var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "article" }, [
    _c("div", { staticClass: "article-content" }, [
      _vm.articleInfo
        ? _c("div", { staticClass: "rich_media_area" }, [
            _c("div", { staticClass: "rich_media_area_primary" }, [
              _c("h2", { staticClass: "rich_media_title" }, [
                _vm._v(_vm._s(_vm.articleInfo.title))
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "rich_media_meta_list" }, [
                _c(
                  "span",
                  { staticClass: "rich_media_meta rich_media_meta_nickname" },
                  [_vm._v(_vm._s(_vm.articleInfo.author))]
                ),
                _vm._v(" "),
                _c(
                  "em",
                  { staticClass: "rich_media_meta rich_media_meta_text" },
                  [_vm._v(_vm._s(_vm.articleInfo.createDate))]
                )
              ]),
              _vm._v(" "),
              _c("div", {
                staticClass: "rich_media_content",
                staticStyle: { visibility: "visible" },
                domProps: { innerHTML: _vm._s(_vm.articleInfo.content) }
              })
            ]),
            _vm._v(" "),
            _vm.articleInfo.tel
              ? _c("div", { staticClass: "bottom" }, [
                  _c("div", { staticClass: "tel" }, [
                    _vm._m(0),
                    _vm._v(" "),
                    _c("div", [
                      _vm._v("热线电话:" + _vm._s(_vm.articleInfo.tel))
                    ])
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "btn", on: { click: _vm.callPhone } },
                    [_vm._v("立即拨打")]
                  )
                ])
              : _vm._e()
          ])
        : _vm._e(),
      _vm._v(" "),
      !_vm.loading && !_vm.articleInfo
        ? _c("div", { staticClass: "none-content" }, [
            _c("img", {
              staticClass: "deleted",
              attrs: {
                src: require("../../static/images/Article/icon-deleted.png")
              }
            }),
            _vm._v(" "),
            _c("span", { staticClass: "mark" }, [
              _vm._v("该内容已被管理员删除")
            ])
          ])
        : _vm._e()
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", [
      _c("img", {
        attrs: { src: require("../../static/images/Article/phone.png") }
      })
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-25e4bbfc", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-25e4bbfc","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/page/CMS.vue
// module id = null
// module chunks = 